<template>
  <section class="section">
    <div
      class="collapse-item d-flex justify-items-between align-items-center mb-5"
      v-b-toggle.title1
    >
      <h2 class="text-primary font-weight-bold m-0 ml-2">
        {{ content.pv_infoblock_installation_title }}
      </h2>
    </div>
    <b-collapse id="title1" accordion="order-info">
      <div class="content">
        <p v-dynamic-content:pv_infoblock_installation_text></p>
        <ul class="list-check list-unstyled text-left mb-7">
          <li
            v-for="item in installationListItems"
            v-dynamic-content="{ rawText: item }"
            :key="item"
          ></li>
        </ul>
      </div>
    </b-collapse>
  </section>
</template>

<script>
export default {
  name: 'OrderSummaryCardInstallation',
}
</script>
